/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../../core";
import { EnvironmentId } from "../../../commons/types/EnvironmentId";
export const DeleteAllHistoryForUserRequest = core.serialization.object({
    environmentId: EnvironmentId.optional(),
});
